/**
 * PWA version
 */
export const APP_VERSION = '4.46';